import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {updateUserProfile} from "../../modules/User/actions";
import {transitionToPost} from "../../modules/Transition/actions";

const InputNameArea = () => {
    const dispatch = useDispatch();
    const nickname = useSelector(state => state.user.nick_name);

    return (
        <div className="p-grid__input-name">
            <h3>ニックネームを入力</h3>
            <p>プロフィールの設定で後から変更できます。</p>
            <input className="p-input__text" type={"text"} id={"nickname"} defaultValue={nickname} />
            <button className="c-btn-primary" onClick={() => {
                const newNickname = document.getElementById('nickname').value;
                if (newNickname === "") {
                    alert('ニックネームを入力してください。')
                } else {
                    dispatch(updateUserProfile({nick_name: newNickname}));
                    dispatch(transitionToPost())
                }
            }}>決定</button>
        </div>
    );
}

export default InputNameArea;